import styled from 'styled-components';
import WithDirection from '../../config/withDirection';

const ProfileWrapper = styled.div`
  .profile-area img {
    max-width: 150px;
    margin-bottom: 20px;
  }

  .panel-body h3 {
    margin-top: 0;
  }
`;
// export default WithDirection(OrderSummaryWrapper);
export default  ProfileWrapper ;


// WEBPACK FOOTER //
// ./src/containers/Profile/style.js